module.exports = __webpack_public_path__ + "img/reg2.427f66b9.png";